import styled from 'styled-components';

export const Page = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
